import HeroSection from "../components/main page/HeroSection";
import HorizontalCard from "../components/main page/HorizontalCard";
import ScrollCountUpCard from "../components/main page/ScrollCountUpCard";
import Facilities from "../components/main page/Facilities";
import Staff from "../components/main page/Staff";
import AdmissionCard from "../components/main page/AdmissionCard";
import Guest from "../components/main page/Guest";
import FeatureCard from "../components/main page/FeatureCard";
import SEO from "../components/SEO";

const Home = () => {
  return (
    <div className="overflow-x-hidden">
      {/* SEO */}
      <SEO
        title="Home"
        description="Official site of St. Thomas Vidyalayam Matric Higher Secondary School, Chennai. Learn about admissions, facilities, staff, and student life."
        keywords="STVMHSS Home, Chennai School, Admissions Open, Best School Chennai"
        canonicalPath="/"
      />

      {/* Screen reader title */}
      <h1 className="sr-only">St. Thomas Vidyalayam — Home</h1>

      <HeroSection />

      <main className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 py-8 sm:py-12 lg:py-16">
        {/* About Section */}
        <section
          className="mb-12 sm:mb-16 md:mb-20"
          aria-labelledby="home-about-heading"
        >
          <h2 id="home-about-heading" className="sr-only">
            About
          </h2>
          <HorizontalCard />
        </section>

        {/* ⭐ Feature Section */}
        <section
          className="my-12 sm:my-16 md:my-20"
          aria-labelledby="home-feature-heading"
        >
          <h2 id="home-feature-heading" className="sr-only">
            Feature Section
          </h2>
          <FeatureCard />
        </section>

        {/* Achievements */}
        <section
          className="my-12 sm:my-16 md:my-20"
          aria-labelledby="home-achievements-heading"
        >
          <h2 id="home-achievements-heading" className="sr-only">
            Achievements
          </h2>
          <ScrollCountUpCard />
        </section>

        {/* Leadership */}
        <section
          className="my-12 sm:my-16 md:my-20"
          aria-labelledby="home-leadership-heading"
        >
          <h2 id="home-leadership-heading" className="sr-only">
            Leadership
          </h2>
          <Staff />
        </section>

        {/* Facilities */}
        <section
          className="my-12 sm:my-16 md:my-20"
          aria-labelledby="home-facilities-heading"
        >
          <h2 id="home-facilities-heading" className="sr-only">
            Facilities
          </h2>
          <Facilities />
        </section>

        {/* Chief Guest */}
        <section
          className="my-12 sm:my-16 md:my-20"
          aria-labelledby="home-guest-heading"
        >
          <h2 id="home-guest-heading" className="sr-only">
            In Focus
          </h2>
          <Guest />
        </section>

        {/* Admission */}
        <section
          className="my-12 sm:my-16 md:my-20"
          aria-labelledby="home-admission-heading"
        >
          <h2 id="home-admission-heading" className="sr-only">
            Admission
          </h2>
          <AdmissionCard />
        </section>
      </main>
    </div>
  );
};

export default Home;
